<div id="sending-modal" class="sending-popup-fixer sending-popup-enviode">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>Envío de Tareas</h2>
    </div>
    <form [formGroup]="taskForm">
        <div class="popoup-content">
            <div class="block-looper-wrapper">
                <div class="block-looper empresa-block">
                    <h2>Empresa</h2>
                    <app-tree-view (companyNode)="onCompanySelcted($event)"></app-tree-view>
                </div>
                <div class="block-looper empresa-block">
                    <h2>Gestor</h2>
                    <mat-form-field appearance="fill">
                        
                        
                        <mat-select [(value)]="SelectedAdministrativeUser" formControlName="SelectedAdministrativeUser"
                            (selectionChange)="onAdminUserChange($event)">
                            <mat-option *ngFor="let user of admintrativeUsers" [value]="user.administrativa">
                                {{user.nombre}}
                            </mat-option>
                            
                                        
                        </mat-select>


                    </mat-form-field>                     
                </div>
                <div class="block-looper">
                    <h2>Enviar a</h2>
                    <fieldset id="Enviar">
                        <legend></legend>
                        <div class="three-view">
                            <label class="container-radio" for="all">Todos los médicos
                                <input type="radio" id="all" value="all" name="Enviar" formControlName="Enviar"
                                    (click)="enviarChangeHandler($event)">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="half">
                            <label class="container-radio" for="single">El medico
                                <input type="radio" id="single" value="single" name="Enviar" formControlName="Enviar"
                                    (click)="enviarChangeHandler($event)">
                                <span class="checkmark"></span>
                            </label>
                        </div>

                        <div class="full" *ngIf="hideElMedicoInput">
                            <mat-form-field appearance="fill">
                                <mat-select [(value)]="SelectedDoctor" panelClass="cus-search-select" formControlName="SelectedDoctor"
                                    (selectionChange)="onDoctorChange($event)">

                                    <input type="text" autocomplete="off" matInput placeholder="búsqueda" #medicoSelect
                                    (input)="SearchDoctors()" />
                                    <div class="search-options">
                                        <mat-option *ngFor="let doctor of _medicoList" [value]="doctor.medicoId">
                                            {{doctor.nombre}}
                                        </mat-option>
                                    </div>
                                    
                                </mat-select>
                            </mat-form-field>
                            <mat-error
                                *ngIf="taskForm.get('SelectedDoctor').invalid && taskForm.get('SelectedDoctor').touched" class="medico-error-task">
                                <span *ngIf="taskForm.get('SelectedDoctor').hasError('required')"> Se debe
                                    indicar el medico</span>
                            </mat-error>
                        </div>              

                    </fieldset>
                </div>
                <div class="block-looper">
                    <h2>Tareas</h2>
                    <fieldset id="Tareas" class="multi-date-wrap">
                        <legend></legend>
                        <div class="three-view">
                            <label class="container-radio" for="PendientesDeNotificarEliminacion">Pendientes de enviar
                                <input type="radio" id="PendientesDeNotificarEliminacion"
                                    value="PendientesDeNotificarEliminacion" (click)="tareasChangeHandler($event)"
                                    name="Tareas" formControlName="Tareas">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="full">
                            <label class="container-radio" for="Enviadas">Enviadas
                                <input type="radio" id="Enviadas" value="Enviadas" (click)="tareasChangeHandler($event)"
                                    name="Tareas" formControlName="Tareas">
                                <span class="checkmark"></span>
                            </label>
                            <div class="" *ngIf="hideEnviadasDateField">
                                <app-date-period-selector [IsBothDatesRequired]="true"
                                    [DateType]="DateFilterType.Common" [PeriodFrom]="getFormControl('DateFrom')"
                                    [PeriodTo]="getFormControl('DateTo')"
                                    (FromDateChanged)="setFilterValues('commonDateFrom', $event)"
                                    (ToDateChanged)="setFilterValues('commonDateTo', $event)">
                                </app-date-period-selector>
                            </div>
                        </div>
                        <div class="full">
                            <label class="container-radio" for="Todas">Todas
                                <input type="radio" id="Todas" value="Todas" (click)="tareasChangeHandler($event)"
                                    name="Tareas" formControlName="Tareas">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </fieldset>

                </div>
                <div class="block-looper">
                    <h2>Grupo de Envío</h2>
                    <div class="full">
                        <mat-form-field appearance="fill">
                            <mat-select [(value)]="selectedReport" formControlName="GrupoDeEnvio"
                                (selectionChange)="onEnvioChange($event)">
                                <mat-option *ngFor="let envio of grupoDeEnvioTypes" [value]="envio.value">
                                    {{envio.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                </div>
                <div class="block-looper">
                    <h2>Fecha de Tarea</h2>
                    <fieldset id="FechaDeTarea" class="single-date-wrap">
                        <legend></legend>
                        <div class="full-view">
                            <label class="container-radio" for="Hasta">Hasta {{currentDate}}
                                <input type="radio" id="Hasta" value="Hasta" (click)="fechaDeTareaChangeHandler($event)"
                                    name="FechaDeTarea" formControlName="FechaDeTarea">
                                <span class="checkmark"></span>
                            </label>

                        </div>
                        <div class="full-view">
                            <label class="container-radio wauto" for="HastaFecha">Hasta fecha
                                <input type="radio" id="HastaFecha" value="HastaFecha"
                                    (click)="fechaDeTareaChangeHandler($event)" name="FechaDeTarea"
                                    formControlName="FechaDeTarea">
                                <span class="checkmark"></span>
                            </label>

                            <div class="single-date" *ngIf="hideHastaFechaDateField">
                                <mat-form-field appearance="fill">
                                    <input matInput [matDatepicker]="picker" name="HastaDate"
                                        formControlName="HastaDate">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <mat-error class="err-last"
                                *ngIf="taskForm.get('HastaDate').invalid && taskForm.get('HastaDate').touched">
                                <span *ngIf="taskForm.get('HastaDate').hasError('required')"> Se debe indicar la fecha
                                    Hasta</span>
                            </mat-error>
                        </div>
                        <div class="full">
                            <label class="container-radio" for="FdTodas">Todas
                                <input type="radio" id="FdTodas" value="FdTodas"
                                    (click)="fechaDeTareaChangeHandler($event)" name="FechaDeTarea"
                                    formControlName="FechaDeTarea">
                                <span class="checkmark"></span>
                            </label>


                        </div>
                    </fieldset>

                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button mat-button color="primary" class="keep" (click)="onSubmit()"><span
                    class="mat-button-wrapper mat-button-wrapper-text-center">Aceptar</span></button>
            <button mat-button color="accent" class="cancel" (click)="close()"><span
                    class="mat-button-wrapper mat-button-wrapper-text-center">Cancelar</span></button>
        </div>
    </form>
</div>